import React from 'react';
import TableDataRowTypes from 'modules/layoutModule/enums/TableDataRowTypes';
import { Image, Tag, Tooltip } from 'antd';
import staticUrl from 'helpers/staticUrl';
import { StaticImagesFallbackUrl } from 'modules/layoutModule/consts/StaticImagesFallbackUrl';
import {
  FileTextOutlined,
  FileImageOutlined,
  VideoCameraOutlined,
  VideoCameraAddOutlined,
  SendOutlined
} from '@ant-design/icons';
import { allModulesList } from 'enums/modulesDefinition';
import moment from 'moment';

interface TableDateRowTypes {
  record: {
    type: number;
    dateAdd: Date;
    dataManualLogin?: Date;
    id: number;
    isActive: boolean | number;
    taste: number;
    colour: number;
    category?: string;
    image?: string;
    url: string | undefined;
    sortOrder?: string;
    viewCount?: string;
    name?: string;
    contentType?: number;
    idCategory?: number;
    idCategory2?: number;
    idCategory3?: number;
    category3?: string;
    category2?: string;
    section1?: string;
    section2?: string;
    section3?: string;
    idSection?: number;
    idSection2?: number;
    idSection3?: number;
    modules?: string;
    videoType?: number;
    isNews?: boolean;
    ask?: boolean;
    color?: string;
    parameters?: number;
    categoryName?: string;
    status?: string;
    representativeName?: string;
  };
  field: string;
  link?: string;
  fieldName?: string;
  size?: number;
  customHeight?: boolean;
  isPng?: boolean;
}

const TableDateRow = ({
  record,
  field,
  link,
  fieldName,
  size,
  customHeight,
  isPng,
}: TableDateRowTypes): JSX.Element => {
  switch (field) {
    case TableDataRowTypes.DATE_ADD:
      return (
        <div style={{ width: 70, fontSize: 12 }}>
          {moment(record.dateAdd).format('DD.MM.YYYY')}
          <br />
          {moment(record.dateAdd).format('HH:mm:ss')}
        </div>
      );
    case TableDataRowTypes.REPRESENTATIVE:
      if (!record.representativeName) {
        return <>-</>;
      }
      return <>{record.representativeName}</>;
    case TableDataRowTypes.GTW_STATUS:
      if (!record.status) {
        return <></>;
      }
      return (
        <div className="list-thumb">
          <Image
            src={`${staticUrl()}${record.status}_big.png`}
            fallback={StaticImagesFallbackUrl}
            width={size ? size : ''}
            height={customHeight ? 'auto' : ''}
            preview={false}
          />
        </div>
      );
    case TableDataRowTypes.GTW_DATE:
      // @ts-ignore
      if (fieldName && !record[fieldName]) {
        return <></>;
      }
      // @ts-ignore
      const indexField = record[fieldName];
      return (
        <div style={{ width: 70, fontSize: 12 }}>
          {moment(indexField).format('DD.MM.YYYY')}
        </div>
      );
    case TableDataRowTypes.COLOUR:
      return (
        <>
          <div
            style={{
              width: 25,
              height: 25,
              backgroundColor: record.color,
              borderRadius: '50%',
            }}
          />
        </>
      );
    case TableDataRowTypes.DATE_LOGIN:
      return (
        <div style={{ width: 70, fontSize: 12 }}>
          {moment(record.dataManualLogin).format('DD.MM.YYYY')}
          <br />
          {moment(record.dataManualLogin).format('HH:mm:ss')}
        </div>
      );
    case TableDataRowTypes.SORT:
      return <>{record.sortOrder}</>;
    case TableDataRowTypes.FIELD_NEWS_TYPE:
      if (record.contentType === 1) {
        return (
          <Tooltip placement="top" title="Wiadomość tekstowa">
            <FileTextOutlined style={{ fontSize: '26px' }} />
          </Tooltip>
        );
      }
      if (record.contentType === 2) {
        return (
          <Tooltip placement="top" title="Galeria zdjęć">
            <FileImageOutlined style={{ fontSize: '25px' }} />
          </Tooltip>
        );
      }
      if (record.contentType === 3) {
        return (
          <Tooltip placement="top" title="Video">
            <VideoCameraOutlined style={{ fontSize: '25px' }} />
          </Tooltip>
        );
      }
      return <></>;
    case TableDataRowTypes.NAME_LINK:
      if (!record.isActive) {
        return <>{record.name}</>;
      }
      return (
        <a href={`https://nawozy.eu/${link}`} target="_blank" rel="noreferrer">
          {record.name}
        </a>
      );
    case TableDataRowTypes.VIEWS:
      return <>{record.viewCount}</>;
    case TableDataRowTypes.IMAGE:
      const fieldNameParseImage =
        // @ts-ignore
        fieldName && record[fieldName] ? record[fieldName] : record.image;
      const extension = isPng ? 'png' : 'jpg';
      const imageUrl = () => {
        if (!fieldNameParseImage) {
          return 'error';
        }
        return `${staticUrl()}${fieldNameParseImage}_medium.${extension}`;
      };
      const imagePreviewUrl = () => {
        if (!fieldNameParseImage) {
          return false;
        }
        return {
          src: `${staticUrl()}${fieldNameParseImage}_big.${extension}`,
        };
      };

      return (
        <div className="list-thumb">
          <Image
            key={fieldNameParseImage}
            src={imageUrl()}
            preview={imagePreviewUrl()}
            fallback={StaticImagesFallbackUrl}
            width={size ? size : ''}
            height={customHeight ? 'auto' : ''}
          />
        </div>
      );
    case TableDataRowTypes.FERTILIZER_IMAGE:
      const fieldNameParseImageFertilizer =
        // @ts-ignore
        fieldName && record[fieldName] ? record[fieldName] : record.image;
      const imageUrlFertilizer = () => {
        if (!fieldNameParseImageFertilizer) {
          return 'error';
        }
        return `${staticUrl()}${fieldNameParseImageFertilizer}_big.png`;
      };
      const imagePreviewUrlFertilizer = () => {
        if (!fieldNameParseImageFertilizer) {
          return false;
        }
        return {
          src: `${staticUrl()}${fieldNameParseImageFertilizer}_big.png`,
        };
      };

      return (
        <div className="list-thumb">
          <Image
            key={fieldNameParseImageFertilizer}
            src={imageUrlFertilizer()}
            preview={imagePreviewUrlFertilizer()}
            fallback={StaticImagesFallbackUrl}
            width={size ? size : ''}
            height={customHeight ? 'auto' : ''}
          />
        </div>
      );
    case TableDataRowTypes.BANNERS:
      const fieldNameBannersParseImage =
        // @ts-ignore
        fieldName && record[fieldName] ? record[fieldName] : record.image;
      const imageBannerUrl = () => {
        if (!fieldNameBannersParseImage) {
          return 'error';
        }
        return `${staticUrl()}${fieldNameBannersParseImage}`;
      };
      const imageBannerPreviewUrl = () => {
        if (!fieldNameBannersParseImage) {
          return false;
        }
        return {
          src: `${staticUrl()}${fieldNameBannersParseImage}`,
        };
      };

      return (
        <div className="list-thumb">
          <Image
            key={fieldNameBannersParseImage}
            src={imageBannerUrl()}
            preview={imageBannerPreviewUrl()}
            fallback={StaticImagesFallbackUrl}
            width={size ? size : 130}
            height="auto"
          />
        </div>
      );
    case TableDataRowTypes.CUSTOM_IMAGE:
      const fieldNameParse =
        // @ts-ignore
        fieldName && record[fieldName] ? record[fieldName] : record.image;
      const customImageUrl = () => {
        if (!fieldNameParse) {
          return 'error';
        }
        return `${staticUrl()}${fieldNameParse}`;
      };
      const customImagePreviewUrl = () => {
        if (!fieldNameParse) {
          return false;
        }
        return {
          src: `${staticUrl()}${fieldNameParse}`,
        };
      };

      return (
        <div className="list-thumb">
          <Image
            key={fieldNameParse}
            src={customImageUrl()}
            preview={customImagePreviewUrl()}
            fallback={StaticImagesFallbackUrl}
            width={size ? size : 130}
            height="auto"
          />
        </div>
      );
    case TableDataRowTypes.GTW_REQUIREMENT:
      const fieldNameParseGtw =
        // @ts-ignore
        fieldName && record[fieldName] ? record[fieldName] : record.image;
      const fileUrl = fieldNameParseGtw.includes('.png')
        ? fieldNameParseGtw
        : `${fieldNameParseGtw}_big.png`;
      const customImageUrlGtw = () => {
        if (!fileUrl) {
          return 'error';
        }
        return `${staticUrl()}${fileUrl}`;
      };
      const customImagePreviewUrlGtw = () => {
        if (!fileUrl) {
          return false;
        }
        return {
          src: `${staticUrl()}${fileUrl}`,
        };
      };

      return (
        <div className="list-thumb">
          <Image
            key={fileUrl}
            src={customImageUrlGtw()}
            preview={customImagePreviewUrlGtw()}
            fallback={StaticImagesFallbackUrl}
            width={size ? size : 130}
            height="auto"
          />
        </div>
      );
    case TableDataRowTypes.AVATAR:
      const avatarUrl = () => {
        if (!record.image) {
          return 'error';
        }
        return `${staticUrl()}${record.image}_medium.jpg`;
      };
      const avatarPreviewUrl = () => {
        if (!record.image) {
          return false;
        }
        return {
          src: `${staticUrl()}${record.image}_medium.jpg`,
        };
      };

      return (
        <div className="list-thumb">
          <Image
            key={record.image}
            src={avatarUrl()}
            preview={avatarPreviewUrl()}
            fallback={StaticImagesFallbackUrl}
            width={100}
            height={100}
          />
        </div>
      );
    case TableDataRowTypes.NAWOZY_TV_TYPE:
      if (record.videoType === 1) {
        return (
          <Tooltip placement="top" title="Nawozy Nonstop">
            <VideoCameraAddOutlined style={{ fontSize: '26px' }} />
          </Tooltip>
        );
      }
      if (record.videoType === 2) {
        return (
          <Tooltip placement="top" title="Wiadomości Nonstop">
            <VideoCameraOutlined style={{ fontSize: '26px' }} />
          </Tooltip>
        );
      }
      if (record.videoType === 3) {
        return (
          <Tooltip placement="top" title="Shorts">
            <SendOutlined style={{ fontSize: '26px' }} />
          </Tooltip>
        );
      }
      return <></>;
    case TableDataRowTypes.CATEGORY_TAG:
      // @ts-ignore
      if (fieldName && fieldName && !record[fieldName]) {
        return <></>;
      }
      //@ts-ignore
      const nameCategory = fieldName ? record[fieldName] : record.category;
      return <Tag>{nameCategory}</Tag>;
    case TableDataRowTypes.MODULES:
      if (!record.modules) {
        return <></>;
      }
      const modules = JSON.parse(record.modules);
      return modules.map((module: any) => {
        const findName = allModulesList.find(
          (moduleFromList) => moduleFromList.id === module
        );
        if (findName) {
          return (
            <Tag key={`tag-${module}`} style={{ marginBottom: 5 }}>
              {findName.title}
            </Tag>
          );
        }
      });
    case TableDataRowTypes.FIELD_NEWS_CATEGORY:
      const categories = [];
      if (record.idCategory) {
        categories.push(
          <Tag style={{ marginBottom: 5 }}>{record.category}</Tag>
        );
      }
      if (record.idCategory2) {
        categories.push(
          <Tag style={{ marginBottom: 5 }}>{record.category2}</Tag>
        );
      }
      if (record.idCategory3) {
        categories.push(
          <Tag style={{ marginBottom: 5 }}>{record.category3}</Tag>
        );
      }
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          {categories.map((category) => (
            <>{category}</>
          ))}
        </div>
      );
    case TableDataRowTypes.FIELD_NEWS_SECTIONS:
      const sections = [];
      if (record.idSection) {
        sections.push(<Tag style={{ marginBottom: 5 }}>{record.section1}</Tag>);
      }
      if (record.idSection2) {
        sections.push(<Tag style={{ marginBottom: 5 }}>{record.section2}</Tag>);
      }
      if (record.idSection3) {
        sections.push(<Tag style={{ marginBottom: 5 }}>{record.section3}</Tag>);
      }
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          {sections.map((section) => (
            <>{section}</>
          ))}
        </div>
      );
    case TableDataRowTypes.IS_ACTIVE:
      if (record.isActive) {
        return <Tag color="green">TAK</Tag>;
      }
      return <Tag color="red">NIE</Tag>;
    case TableDataRowTypes.HAS_PARAMETERS:
      if (record.parameters) {
        return <Tag color="green">TAK</Tag>;
      }
      return <Tag color="red">NIE</Tag>;
    case TableDataRowTypes.IS_NEWS:
      if (record.isNews) {
        return <Tag color="green">TAK</Tag>;
      }
      return <Tag color="red">NIE</Tag>;
    case TableDataRowTypes.IS_ASK:
      if (record.ask) {
        return <Tag color="green">TAK</Tag>;
      }
      return <Tag color="red">NIE</Tag>;
  }
  return <></>;
};

export default TableDateRow;
